export default __webpack_public_path__ + "static/media/pBREW.65b1389a.png";